import * as Actions from '../../../Modules/CmsActions'

const initialState = {
  loading: false,
  saving: false,
  success: false,
  edit: null,
  list: [],
  conditions: {
    tab: 'custom',
    orderBy: 'created_at',
    order: 'desc',
    name: '',
  },
  pagination: {
    current_page: 1,
    first_page_url: null,
    from: null,
    last_page: null,
    last_page_url: null,
    next_page_url: null,
    path: null,
    per_page: 15,
    prev_page_url: null,
    to: null,
    total: 0,
  },
}

const UIPropertyReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.REQUEST_SHOW_PROPERTY_LIST:
    case Actions.REQUEST_SHOW_PROPERTY:
      return loading(state)
    case Actions.SUCCESS_SHOW_PROPERTY_LIST:
      return updateList(state, action.payload)
    case Actions.FAILURE_SHOW_PROPERTY_LIST:
    case Actions.FAILURE_SHOW_PROPERTY:
      return { ...state, loading: false }
    case Actions.SUCCESS_SHOW_PROPERTY:
      return updateEdit(state, action.payload)
    case Actions.UNLOAD_PROPERTY:
      return { ...state, edit: null }
    case Actions.UNLOAD_PROPERTY_LIST:
      return { ...state, list: [] }
    case Actions.CHANGE_PROPERTY_CONDITION:
      return updateCondition(state, action.payload)
    case Actions.CHANGE_PROPERTY_PAGINATION:
      return updatePagination(state, action.payload)
    case Actions.REQUEST_UPDATE_PROPERTY:
    case Actions.REQUEST_CREATE_PROPERTY:
    case Actions.REQUEST_DELETE_PROPERTY:
      return { ...state, saving: true }
    case Actions.SUCCESS_UPDATE_PROPERTY:
    case Actions.FAILURE_UPDATE_PROPERTY:
    case Actions.SUCCESS_CREATE_PROPERTY:
    case Actions.FAILURE_CREATE_PROPERTY:
    case Actions.SUCCESS_DELETE_PROPERTY:
    case Actions.FAILURE_DELETE_PROPERTY:
      return { ...state, saving: false }
    case Actions.LOCAL_UPDATE_PROPERTY_LIST:
      return { ...state, list: action.payload.list }
    default:
      return state
  }
}

const loading = (state) => {
  return { ...state, loading: true }
}

const updateList = (state, payload) => {
  return {
    ...state,
    loading: false,
    list: payload.list,
    customList: payload.customList ?? state.customList,
    templateList: payload.templateList ?? state.templateList,
    pagination: payload.pagination,
  }
}

const updateEdit = (state, payload) => {
  return {
    ...state,
    loading: false,
    edit: payload.property,
  }
}

const updateCondition = (state, payload) => {
  return {
    ...state,
    conditions: payload.conditions,
  }
}

const updatePagination = (state, payload) => {
  return {
    ...state,
    pagination: payload.pagination,
  }
}

export default UIPropertyReducer
